export default import.meta.ROLLDOWN_FILE_URL_s7motFCfQkny44w9LPnPqg